import Cuttr from 'cuttr';

const COPY = {
  de: {
    more: 'Mehr',
    less: 'Weniger',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen'
  },
  en: {
    more: 'More',
    less: 'Less',
    showMore: 'Show more',
    showLess: 'Show less'
  }
};

document.addEventListener("turbo:load", function () {
  const copy = COPY[document.documentElement.lang] || COPY.de;

  new Cuttr('.show-more--bio', {
    licenseKey: '218D9D9B-58BB444C-9E13E76B-E5139D1F',
    truncate: 'words',
    length: 30,
    readMore: true,
    readMoreText: copy.more,
    readLessText: copy.less,
    readMoreBtnTag: 'a'
  });

  new Cuttr('.show-more--feedback', {
    licenseKey: '218D9D9B-58BB444C-9E13E76B-E5139D1F',
    truncate: 'characters',
    length: 120,
    readMore: true,
    readMoreText: copy.more,
    readLessText: copy.less,
    readMoreBtnPosition: 'inside',
    readMoreBtnTag: 'a',
    readMoreBtnAdditionalClasses: 'link-dark fw-medium'
  });

  new Cuttr('.show-more--course-description', {
    licenseKey: '218D9D9B-58BB444C-9E13E76B-E5139D1F',
    truncate: 'words',
    length: 60,
    readMore: true,
    readMoreText: copy.showMore,
    readLessText: copy.showLess,
    readMoreBtnPosition: 'after',
    readMoreBtnTag: 'button',
    readMoreBtnAdditionalClasses: 'btn btn-light px-4 py-2h mt-2'
  });
});
